'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
  Small library to facilitate simpler handling of asynchronous (promise based) actions in redux
  Usage:
    - wrapping an action constant in asynch(CONSTANT) adds .loading and .failure attributes, which can be matched on in a reducer
    - add the `middleware` (below) to the redux store to handle asynch(..) actions
*/

var SUCCESS = 'success';
var FAILURE = 'failure';
var LOADING = 'loading';

var AsynchSymbol = '@@asynch';

var asynch = exports.asynch = function asynch(t) {

  var result = function result() {};
  result.toString = function () {
    return t;
  };
  result[AsynchSymbol] = true;

  result.success = t;
  result.loading = t + ':' + LOADING;
  result.failure = t + ':' + FAILURE;

  return result;
};

var loading = exports.loading = function loading(t) {
  if (!t.loading) console.warn('Asynch: loading() used on non-asynch action ' + t);
  return t.loading || t + ':' + LOADING;
};

/**
 * Lets you dispatch special actions with a { promise } field.
 *
 * This middleware will turn them into a single action at the beginning,
 * and a single success (or failure) action when the `promise` resolves.
 *
 * For convenience, `dispatch` will return the promise so the caller can wait.
 */
var middleware = exports.middleware = function middleware(store) {
  return function (next) {
    return function (action) {
      if (action.promise && !action.type[AsynchSymbol]) {
        console.warn(action.type + ' action has promise, but is not an asynch action. Consider adding asynch(..) to definition');
        return next(action);
      }
      if (!action.type[AsynchSymbol] && !action[AsynchSymbol]) {
        return next(action);
      }

      function makeAction(readyState, data) {
        var type = action.type[readyState];
        var ready = readyState !== LOADING;
        var newAction = Object.defineProperty(Object.assign({}, action, { ready: ready, type: type }, data), AsynchSymbol, { value: true });

        delete newAction.promise;
        return newAction;
      }

      next(makeAction(LOADING));
      return action.promise.then(function (result) {
        setImmediate(function () {
          return next(makeAction(SUCCESS, { result: result }));
        });
        return result;
      }, function (error) {
        console.error(action.type + ' action encountered error:', error);
        setImmediate(function () {
          return next(makeAction(FAILURE, { error: error }));
        });
        throw error;
      });
    };
  };
};

exports.default = asynch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-asynch-middleware/dist/index.js
// module id = 16
// module chunks = 34